export const aboutEn = {
  hero: {
    title: 'Our Story',
    subtitle: 'From the sunny streets of Naples to the heart of downtown Reykjavik',
  },
  history: {
    title: 'Our History',
    content: [
      "Rossopomodoro was founded in Naples in 1997 with a simple mission: to share the authentic taste of Neapolitan cuisine with the world. Today, it has grown into an international restaurant chain with locations across Italy, the UK, France, Germany, Iceland, Turkey, Denmark, the US, Saudi Arabia, Japan, Brazil, Czechia and Malta. Our Reykjavik location opened in 2006, bringing authentic Italian cuisine to the heart of Iceland's capital.",
      "Rossopomodoro is a snapshot of life in Naples, southern Italy—the look of the restaurant, the menu, and the staff's attire all reflect that ethos. Located on Laugavegur, Reykjavik's main shopping street, we've become a favorite dining destination for locals and tourists seeking the best Italian food in Reykjavik.",
      'Our wood-fired oven was built by third-generation Neapolitan artisans and shipped all the way to Iceland. The volcanic stone used in its construction creates the perfect cooking environment for our pizzas, reaching temperatures of 485°C (905°F) and cooking a perfect Neapolitan pizza in just 90 seconds. This authentic approach is why many consider us the best pizza restaurant in Reykjavik.',
    ],
    since: 'Since 2006',
  },
  location: {
    title: 'Visit Us',
    subtitle: 'Located in the heart of Reykjavik on the vibrant Laugavegur street',
    content: [
      "Our Italian restaurant is perfectly situated on Laugavegur 40a, Reykjavik's main shopping street, making it easily accessible whether you're exploring downtown Reykjavik or looking for the best pizza in the city center.",
      "We're just a short walk from major landmarks including Hallgrímskirkja church, the Harpa Concert Hall, and the old harbor. Street parking and public transportation are readily available, making us easy to find in central Reykjavik.",
    ],
    address: 'Laugavegi 40a, 101 Reykjavík',
    directions: 'Get Directions',
    poi: {
      hallgrimskirkja: {
        name: 'Hallgrímskirkja',
        distance: '350 m',
        walkTime: '5 min walk',
      },
      harpa: {
        name: 'Harpa',
        distance: '850 m',
        walkTime: '13 min walk',
      },
    },
  },
  values: {
    title: 'Our Values',
    subtitle: 'The principles that guide everything we do',
    items: [
      {
        title: 'Authenticity',
        description:
          "We don't compromise on authenticity. From our ingredients to our techniques, everything we do stays true to Neapolitan traditions.",
      },
      {
        title: 'Quality',
        description:
          'We use only the finest ingredients, many imported directly from Italy, and combine them with the best local produce Iceland has to offer.',
      },
      {
        title: 'Hospitality',
        description:
          'We welcome every guest like family. Our warm, attentive service reflects the genuine Italian hospitality tradition.',
      },
    ],
  },
};
